  // In a plugin file or main entry file like app.vue
export default defineNuxtPlugin(nuxtApp => {
    // Disable all Vue warnings
    nuxtApp.vueApp.config.warnHandler = () => {};
  });
  